import { GET_PATIENTS_SUCCESS, GET_SINGLE_PATIENT_SUCCESS } from "./patients.types";

const initialState = {
  patientsList: null,
  singlePatient: null,
};

export const patientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PATIENTS_SUCCESS:
      return {
        ...state,
        patientsList: action.payload,
      };

    case GET_SINGLE_PATIENT_SUCCESS:
      return {
        ...state,
        singlePatient: action.payload,
      };

    default:
      return state;
  }
};
